module.exports = __webpack_public_path__ + "static/img/1.4ca2555.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/1.png
// module id = GxLg
// module chunks = 0